import { connect } from 'react-redux'
import EditarChargebackModal from './modal';

export default connect()(EditarChargebackModal);
